import { gql } from '@apollo/client';

export const ADVANTAGE_PAYLOAD = gql`
    fragment AdvantageFragment on Advantage {
        _id
        name
        icon
        category
    }
`;

export const getAdvantagesQuery = gql`
    query getAdvantages {
        advantages: getAdvantages {
            ...AdvantageFragment
        }
    }
    ${ADVANTAGE_PAYLOAD}
`;

export const ADD_ADVANTAGE_PRO = gql`
  mutation addAdvantagePro($name: String!, $icon: String, $order: Int) {
    data: addAdvantagePro(name: $name, icon: $icon, order: $order) {
      _id
      name
      icon
      category
      status
      order
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_ADVANTAGE_PRO = gql`
  mutation deleteAdvantagePro($id: ID!) {
    deleteAdvantagePro(id: $id)
  }
`;
